import EventoHistorico from './EventoHistorico'

export default EventoHistorico